import { get } from '../../../container';
import SERVICES from '../../../api/query/Services';
import { getMembersFromService } from '../../members/actions/members';

export const GET_ALL_SERVICES_LOADING = 'GET_ALL_SERVICES_LOADING';
export const GET_ALL_SERVICES_SUCCESS = 'GET_ALL_SERVICES_SUCCESS';
export const GET_ALL_SERVICES_FAILURE = 'GET_ALL_SERVICES_FAILURE';
export const RETRIEVE_SERVICE_SUCCESS = 'RETRIEVE_SERVICE_SUCCESS';
export const RETRIEVE_SERVICE_FAILURE = 'RETRIEVE_SERVICE_FAILURE';

export function getAllServices() {
  return (dispatch) => {
    dispatch({ type: GET_ALL_SERVICES_LOADING });

    get('graphql').query(SERVICES, undefined, ({ data }) => {
      const list = data.Services;

      dispatch({ type: GET_ALL_SERVICES_SUCCESS, payload: { list } });
    }, (status) => dispatch({ type: GET_ALL_SERVICES_FAILURE, payload: { status } }));
  };
}

/**
 * @param {String} name
 */
export function retrieveService(name) {
  return (dispatch, getState) => {
    const service = getState().services.list.find(item => item.name.toLowerCase().includes(name));

    if (service) {
      dispatch({ type: RETRIEVE_SERVICE_SUCCESS });
      dispatch(getMembersFromService(service));
    } else {
      dispatch({ type: RETRIEVE_SERVICE_FAILURE });
      dispatch(getMembersFromService({ uuid: undefined, name }));
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/services/actions/services.js